module.exports = __webpack_public_path__ + "img/mejs-controls-bette.4d98d88.svg";